export default __webpack_public_path__ + "static/media/cow.6b55538c.svg";